import React from "react";
import { makeStyles } from "@material-ui/core";
import { useLottie } from "lottie-react";

const useStyles = makeStyles((theme) => ({
  animation: {
    pointerEvents: "none",
    marginTop: theme.spacing(4),
  },
}));

interface AnimateProps {
  animationData: any;
  loop?: boolean;
  autoplay?: boolean;
}

export default function Animate({
  animationData,
  loop = true,
  autoplay = true,
}: AnimateProps) {
  const classes = useStyles();

  const options = {
    animationData: animationData,
    loop: loop,
    autoplay: autoplay,
  };

  const { View } = useLottie(options);

  return <div className={classes.animation}>{View}</div>;
}
